import { AfterViewInit, Component, inject } from '@angular/core'
import { Navbar } from '../../../common/navbar/navbar.component'
import { Modal } from 'bootstrap'
import { AbstractRider } from '../../../../modal/person.modal'
import { FormControl, ReactiveFormsModule } from '@angular/forms'
import { TranslatePipe, TranslateService } from '@ngx-translate/core'
import { ClassService } from '../../../../services/class.service'
import { map } from 'rxjs'
import { commonUtil } from '../../../../utils/common.util'

interface ClassAttendenceRider {
  rider: AbstractRider
  isAttendanceControl: FormControl<string>
}

@Component({
  selector: 'app-rider-attendance',
  imports: [Navbar, ReactiveFormsModule, TranslatePipe],
  templateUrl: './rider-attendance.component.html',
  styleUrl: './rider-attendance.component.css'
})
export class RiderAttendance implements AfterViewInit {
  private classService = inject(ClassService)
  private translateService = inject(TranslateService)
  private modal: Modal | undefined
  private classId?: number
  private changedRiders: Set<ClassAttendenceRider> = new Set()
  riders?: ClassAttendenceRider[]
  isLoading = true
  isUpdating = false

  hide() {
    this.modal?.hide()
  }

  show(classId: number) {
    this.classId = classId
    this.getRiders()
    this.modal?.show()
  }

  mapAttendanceRider(rider: AbstractRider) {
    let control = new FormControl(rider.isAttendance ?? '')
    let atteRider = {
      rider,
      isAttendanceControl: control
    } as ClassAttendenceRider
    control.valueChanges.subscribe((val) => {
      this.changedRiders.add(atteRider)
    })
    return atteRider
  }

  getRiders() {
    if (!this.classId) {
      return
    }
    this.isLoading = true
    this.riders = []
    this.changedRiders.clear()
    this.classService
      .getClassRiders(this.classId)
      .pipe(
        map((riders: AbstractRider[]) =>
          riders.map((r) => this.mapAttendanceRider(r))
        )
      )
      .subscribe({
        next: (riders) => {
          this.isLoading = false
          this.riders?.push(...riders)
        },
        error: () => (this.isLoading = false)
      })
  }

  isAttendanceSet(rider: ClassAttendenceRider) {
    return rider.rider.isAttendance !== null && rider.rider.isAttendance !== undefined
  }

  disableUpdate() {
    return this.changedRiders.size === 0 || this.isLoading || this.isUpdating
  }

  resetRadio(event: Event, control: FormControl) {
    let el = event.target as HTMLInputElement
    if (control.value === el.value) {
      control.setValue('none')
    }
  }

  updateRiderAttendance() {
    if (!this.classId) {
      return
    }

    if (this.changedRiders.size === 0) {
      commonUtil.alert(
        this.translateService.instant(
          'app.volunteerAttendance.attendanceUpdateSuccessfully'
        ),
        'success'
      )
      return
    }

    this.isUpdating = true
    let updateRiders: { id?: number; isAttendance?: string }[] = []
    this.changedRiders.forEach((val) => {
      updateRiders.push({
        id: val.rider.id,
        isAttendance: val.isAttendanceControl.value
      })
    })
    this.classService
      .updateRiderAttendances(this.classId, updateRiders)
      .subscribe({
        next: (success) => {
          this.isUpdating = false
          if (success) {
            this.getRiders()
            commonUtil.alert(
              this.translateService.instant(
                'app.volunteerAttendance.attendanceUpdateSuccessfully'
              ),
              'success'
            )
          }
        },
        error: () => (this.isUpdating = false)
      })
  }

  ngAfterViewInit(): void {
    this.modal = Modal.getOrCreateInstance('#riderAttendance')
  }
}
